module.exports = __webpack_public_path__ + "static/media/mem6.de1fbd06.webp";